import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const QuestionErrorMessage = ({ children }) => (
  <Typography color="error" sx={{ flex: '1 0 auto' }}>
    {children}
  </Typography>
);

QuestionErrorMessage.propTypes = {
  children: PropTypes.any.isRequired,
};

export default QuestionErrorMessage;
